import { useEffect, useState } from "react";
import AdminLayout from "@/components/layout/AdminLayout";
import api from "@/lib/api";
import { toast } from "sonner";
import { Check, Trash2 } from "lucide-react";
import { formatDateTime } from "@/lib/format";

export default function ContactInbox() {
  const [list, setList] = useState([]);
  const [expandedId, setExpandedId] = useState(null);

  const load = async () => {
    try { const { data } = await api.get("/contact-messages"); setList(data); }
    catch { toast.error("Failed to load"); }
  };
  useEffect(() => { load(); }, []);

  const handle = async (m) => {
    try { await api.patch(`/contact-messages/${m.id}`); toast.success("Marked handled"); load(); }
    catch { toast.error("Failed"); }
  };
  const del = async (m) => {
    if (!confirm("Delete this message?")) return;
    try { await api.delete(`/contact-messages/${m.id}`); toast.success("Deleted"); load(); }
    catch { toast.error("Failed"); }
  };

  return (
    <AdminLayout title="Contact Inbox">
      <div className="text-sm text-[color:var(--ivory-muted)] mb-6">{list.length} message{list.length !== 1 ? "s" : ""}</div>
      <div className="space-y-3">
        {list.map((m) => (
          <div key={m.id} className={`rounded-2xl border border-white/10 bg-white/[0.02] ${m.handled ? "opacity-70" : ""}`} data-testid={`message-${m.id}`}>
            <div className="p-5 cursor-pointer" onClick={() => setExpandedId(expandedId === m.id ? null : m.id)}>
              <div className="flex items-center justify-between gap-4 flex-wrap">
                <div>
                  <div className="font-medium">{m.subject}</div>
                  <div className="text-sm text-[color:var(--ivory-muted)] mt-0.5">{m.name} · {m.email}{m.phone ? ` · ${m.phone}` : ""}</div>
                </div>
                <div className="flex items-center gap-2 text-xs text-[color:var(--ivory-muted)]">
                  {formatDateTime(m.created_at)}
                  {m.handled && <span className="px-2 py-0.5 rounded-full bg-[color:var(--bd-green)]/20 text-[color:var(--bd-green-bright)]">Handled</span>}
                </div>
              </div>
              {expandedId === m.id && (
                <div className="mt-4 pt-4 border-t border-white/5">
                  <p className="text-sm whitespace-pre-wrap leading-relaxed">{m.message}</p>
                  <div className="mt-4 flex gap-3">
                    {!m.handled && (
                      <button onClick={(e) => { e.stopPropagation(); handle(m); }} className="pill pill-primary text-xs inline-flex items-center gap-1.5">
                        <Check className="w-3.5 h-3.5" /> Mark handled
                      </button>
                    )}
                    <a onClick={(e) => e.stopPropagation()} href={`mailto:${m.email}?subject=Re: ${encodeURIComponent(m.subject)}`} className="pill border border-white/15 text-white text-xs">
                      Reply via email
                    </a>
                    <button onClick={(e) => { e.stopPropagation(); del(m); }} className="pill border border-[color:var(--bd-red)]/30 text-[color:var(--bd-red-bright)] text-xs inline-flex items-center gap-1.5">
                      <Trash2 className="w-3.5 h-3.5" /> Delete
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
        {list.length === 0 && <div className="p-12 text-center text-[color:var(--ivory-muted)] rounded-2xl border border-white/10 bg-white/[0.02]">No messages yet.</div>}
      </div>
    </AdminLayout>
  );
}
